import { useEffect, useState } from "react";
import { createContext } from "react";
import { getSafeAsseblePoint } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";
import { useNavigate, useLocation } from "react-router-dom";

export const SafeAssemblePointContext = createContext({});
export const SafeAssemblePointContextProvider = ({ children }) => {
  const [listData, setListData] = useState([]);
  const [statusData, setStatusData] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [statusCode, setStatusCode] = useState(0);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  // --------------------------------------------------------------
  const [activeCardZone1, setActiveCardZone1] = useState(true);
  const [activeCardZone2, setActiveCardZone2] = useState(false);
  const [zone, setZone] = useState(1);
  const [zoneTotalCount, setZoneTotalCount] = useState(null);
  const [assembleCount, setAssembleCount] = useState({
    safeAssembleCount: "",
    remainingCount: "",
  });
  const navigate = useNavigate();
  const getSafeAsseblePointData = async (status, page, zone) => {
    setSpinnerStatus(true);
    setShowAlert(false);
    const data = {
      status: status,
      page: page,
      zone: zone,
    };
    try {
      const response = await getSafeAsseblePoint(data);
      if (response?.data?.status === 200) {
        const assembleDetails = response?.data?.data;
        setShowAlert(false);
        setSpinnerStatus(false);
        setZoneTotalCount(assembleDetails?.zoneTotalCount);
        setAssembleCount({
          safeAssembleCount: assembleDetails?.safeAssembleCount,
          remainingCount: assembleDetails?.userZoneCount,
        });
        setPageCount(response?.data?.data?.numPages);
        setListData(response?.data?.data?.users);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };
  useEffect(() => {
    setPageNumber(1);
    getSafeAsseblePointData(statusData, 1, zone);
  }, [statusData, zone]);

  const onPageChange = (e) => {
    setPageNumber(e);
    getSafeAsseblePointData(statusData, e, zone);
  };

  const onCLickZoneOne = () => {
    setZone(1);
    setActiveCardZone1(true);
    setActiveCardZone2(false);
  };

  const onCLickZoneTwo = () => {
    setZone(2);
    setActiveCardZone1(false);
    setActiveCardZone2(true);
    true;
  };

  const providerValue = {
    listData,
    getSafeAsseblePointData,
    pageCount,
    pageNumber,
    onPageChange,
    alertMessage,
    setAlertMessage,
    showAlert,
    setShowAlert,
    setStatusData,
    statusData,
    logout,
    statusCode,
    spinnerStatus,
    setSpinnerStatus,
    setZone,
    zoneTotalCount,
    assembleCount,
    onCLickZoneOne,
    onCLickZoneTwo,
    activeCardZone1,
    activeCardZone2,
  };

  return (
    <SafeAssemblePointContext.Provider value={providerValue}>
      {children}
    </SafeAssemblePointContext.Provider>
  );
};
